import MenuComponent from '@/components/MenuComponent'
import MenuConnexion from '@/components/MenuConnexion'
import BlocAuthenticated from '@/components/BlocAuthenticated'

import { BatchLogsSearch } from '@/models/batchlogs.model'

export default {
  components: {
    MenuComponent,
    MenuConnexion,
    BlocAuthenticated
  },
  data () {
    return {
      batchLogsSearch: new BatchLogsSearch(),
      loading: false,
      ordering: ['', 'ASC', 'DESC'],
      batchNames: this.$store.state.user.batchLogsList ? this.$store.state.user.batchLogsList.batchNames : [],
      currentPage: this.$route.hash ? this.$route.hash.split('#')[1] : 1,
      perPage: 50,
      totalItems: this.$store.state.user.batchLogsList ? this.$store.state.user.batchLogsList.nbTotalResults : 0,
      pages: this.$store.state.user.batchLogsList ? Math.ceil(this.$store.state.user.batchLogsList.nbTotalResults / 50) : 0

    }
  },
  methods: {
    async getBatchLogs (beginIndex) {
      if (!this.batchLogsSearch.dateDebut) {
        this.batchLogsSearch.dateDebut = null
      }
      if (!this.batchLogsSearch.dateFin) {
        this.batchLogsSearch.dateFin = null
      }
      if (!this.batchLogsSearch.execDateOrder || !this.batchLogsSearch.execDateOrder.length) {
        this.batchLogsSearch.execDateOrder = null
      }

      this.batchLogsSearch.beginIndex = this.perPage * beginIndex
      this.batchLogsSearch.endIndex = parseInt(this.batchLogsSearch.beginIndex) + this.perPage
      this.loading = true
      this.$store.dispatch('user/getBatchLogs', this.batchLogsSearch).then(
        response => {
          this.batchNames = this.$store.state.user.batchLogsList.batchNames
          this.totalItems = this.$store.state.user.batchLogsList.nbTotalResults
          this.pages = Math.ceil(this.totalItems / this.perPage)
          this.loading = false
        },
        error => {
          this.loading = false
          this.errorMessage = error.response.data
        }
      )
    },
    getStatusString (status) {
      if (status) {
        return 'OK'
      }
      return 'KO'
    },
    format_date (value) {
      var moment = require('moment')
      if (value) {
        return moment(value).format('DD/MM/YYYY HH:mm:ss')
      }
    },
    format_milliseconds (value) {
      if (value) {
        var date = new Date(0)
        date.setSeconds(value)
        return date.toISOString().substr(14, 5)
      }
    },
    changeAvailablePage () {
      this.$store.dispatch('user/deleteBatchLogsList')

      this.getBatchLogs(this.currentPage - 1)
    },
    resetForm () {
      this.batchLogsSearch = new BatchLogsSearch()
    }
  },
  created () {
    if (!this.$store.state.user.batchLogsList || !this.$store.state.user.batchLogsList.length) {
      this.getBatchLogs(0)
    }
  },
  mounted () {
    var self = this
    $( function () {
      $('#datedebut').datepicker({
        onSelect: function (dateText) {
          self.batchLogsSearch.dateDebut = dateText
        }
      })
      $('#datefin').datepicker({
        onSelect: function (dateText) {
          self.batchLogsSearch.dateFin = dateText
        }
      })
    })
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'BatchLogs'
    this.$store.state.filArianeMiddlePage = null
    this.$store.state.filArianeMiddleRouterLink = null
  }
}
